module.exports = __webpack_public_path__ + "img/stories.e555d7a5.png";